
import { constants as fromDrivers } from 'features/drivers'
import { useNavigate } from 'react-router-dom'

import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'

const PromoCard = () => {
  const navigate = useNavigate()

  const onInviteDriver = () => navigate(fromDrivers.PATH_ALL)

  return (
    <Card
      sx={{
        height: '440px',
        '@media (max-width: 600px)': { height: '100%' },
        backgroundColor: '#002849',
        backgroundSize: '250px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '-50px -30px',
        backgroundImage: 'url("/static/images/marketing/car.png")',
      }}>
      <CardContent>
        <Grid container alignItems="center" mr={1} ml={1}>

          <Grid item xs={12} sm={4} md={3} lg={3}>
            <Box
              sx={{
                mt: { xs: 4, sm: 8 },
                textAlign: 'center',
                pr: { xs: 0, sm: 2 },

              }}>
              <Box
                component="img"
                src="/static/images/marketing/dashboard-app-promo.png"
                alt=""
                sx={{
                  width: { xs: '80%', sm: '100%', md: '100%' },
                  height: 'auto',
                  maxHeight: 300,
                  objectFit: 'contain',
                }}/>
            </Box>
          </Grid>

          <Grid item xs={12} sm={8} md={9} lg={9}>
            <Typography
              sx={{
                color: '#FFF',
                fontSize: '16px',
                fontWeight: 'bold',
                textAlign: { xs: 'left', md: 'center', lg: 'left' },
                mt: { xs: 2, sm: 6 },
              }}>
              Toyota MyDrive
            </Typography>

            <Typography
              sx={{
                color: '#FFF',
                fontSize: '12px',
                mt: 2,
              }}>
                      The MyDrive app provides drivers with a holistic view of their vehicle for the duration of its lifecycle.
                      Whether you are looking to keep up to date with general health and safety obligations, manage incidents or simply update vehicle mileage,
                      the interactive dashboards and in-life notifications will ensure important events are always visible to you.
              <br /><br />
                      Direct integration with the ToyotaFleet Portal ensures that all updates recorded in app are transferred and stored in your ToyotaFleet Portal account, helping you stay on top of managing your fleet.
            </Typography>

            <Box sx={{ mt: 2 }}>
              <Button
                fullWidth
                sx={{ maxWidth: 250 }}
                color="primary"
                variant="contained"
                onClick={onInviteDriver}>
                Invite Driver
              </Button>
            </Box>
          </Grid>

        </Grid>

      </CardContent>
    </Card>
  )
}

export default PromoCard
